import Confirm from 'common/components/Confirm/Confirm';
import React, { useState, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

interface ConfirmWrapProps {
  children: ReactElement;
  message?: string;
  confirmMessageYes?: string;
  confirmMessageNo?: string;
  disabled?: boolean;
  thirdChoiceConfirmAction?: () => void;
  thirdChoiceConfirmLabel?: string;
}

function ConfirmWrap({
  children,
  message,
  confirmMessageYes,
  confirmMessageNo,
  disabled,
  thirdChoiceConfirmAction,
  thirdChoiceConfirmLabel = '',
}: ConfirmWrapProps) {
  const [modalActive, setModalActive] = useState(false);
  const { t } = useTranslation();
  const child = React.Children.only(children);
  const confirmMessage = message ?? t('modal.confirmMessage');

  const handleShow = () => setModalActive(true);
  const closeModal = () => setModalActive(false);

  const handleConfirm = () => {
    if (child.props.onClick) child.props.onClick();
    setModalActive(false);
  };

  if (disabled) {
    return child;
  }

  return (
    <>
      {React.cloneElement(child, { onClick: handleShow })}
      <Confirm
        message={confirmMessage}
        show={modalActive}
        confirmModal={handleConfirm}
        closeModal={closeModal}
        confirmMessage={confirmMessageYes}
        confirmCancel={confirmMessageNo}
        thirdChoiceConfirmAction={thirdChoiceConfirmAction}
        thirdChoiceConfirmLabel={thirdChoiceConfirmLabel}
      />
    </>
  );
}

export default ConfirmWrap;
